import React, { useState, useRef } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setCustomerInfo } from "redux/actions";
import Button from "components/Button";
import PhoneNumberInput from "components/PhoneNumberInput";
import Input from "components/Input";
import Dropdown from "components/Dropdown";
import Checkbox from "components/Checkbox";
import Card from "components/Card";
import CardHeader from "components/CardHeader";
import FormContainer from "components/FormContainer";
// import SubscribeSlider from "components/SubscribeSlider";
import { usePlacesWidget } from "react-google-autocomplete";
import { InputRow } from "./styles";
import { OpenNewPageIcon } from "assets/icons";

const GuestInformation = ({
  btnInfo,
  disabled,
  customerStatus,
  type,
  mini,
  customerInfoError,
  setCustomerInfoError,
}) => {
  
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const customerInfo = useSelector(
    (state) => state.customerInfoReducer.customerInfo
  );

  // const currentYear = new Date().getFullYear()

  const phoneNumber = customerInfo.phoneNumber || "";
  const [phoneNumberValidity, setPhoneNumberValidity] = useState(true);

  const updatingRef = useRef(false);

  const handlePhoneChange = (number) => {
    if (updatingRef.current) return;
    if (number === phoneNumber) return;
    // ignore library reset during init
    if (number === "" && phoneNumber !== "") return;
    updatingRef.current = true;
    dispatch(setCustomerInfo({ phoneNumber: number }));
    setCustomerInfoError((prev) => ({
      ...prev,
      phoneNumberError: false,
    }))
    updatingRef.current = false;
  };

  const handleValidityChange = (valid) => {
    setPhoneNumberValidity(valid);
  };

  const { ref } = usePlacesWidget({
    apiKey: `${process.env.REACT_APP_GOOGLE_APIKEY}&loading=async`,
    onPlaceSelected: (place) => {
      const components = place.address_components || [];

      const getComponent = (type) =>
        components.find((component) => component.types.includes(type))
          ?.long_name || "";

      const streetNumber = getComponent("street_number");
      const route = getComponent("route");

      const streetAddress = [streetNumber, route].filter(Boolean).join(" ");
      const streetAddressLine2 = ""; // Google Autocomplete doesn't return this
      const city =
        getComponent("locality") || getComponent("sublocality") || "";
      const province = getComponent("administrative_area_level_1");
      const postalCode = getComponent("postal_code");
      const country = getComponent("country");
      dispatch(
        setCustomerInfo({
          streetAddress,
          streetAddressLine2,
          city,
          province,
          postalCode,
          country,
        })
      );
    },
    options: {
      types: ["address"],
    },
  });

  return (
    <Card>
      <CardHeader
        additionalstyle={
          disabled
            ? null
            : `
          @media only screen and (max-width: 767px) {
            
            .type {
              width: 100%;
              margin-bottom: 10px; 
            }

            .buttonContainer {
              width: 100%;
              justify-content: space-between;
            }
            
            flex-direction: column;
            justify-content: center;
          }
        `
        }
      >
        <div className="cardTitle">
          <div>
            {type
              ? type + " INFORMATION"
              : (customerStatus ? customerStatus + " " : "") +
                "GUEST INFORMATION"}
          </div>
          {customerInfo.tenantId &&
          location.pathname.includes("booking-details") ? (
            <Link
              className="icon"
              to={`/tenant-details/${customerInfo.tenantId}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Open tenant details"
            >
              <OpenNewPageIcon />
            </Link>
          ) : null}
        </div>
        {customerInfo.tenantId &&
        location.pathname.includes("booking-details") ? (
          <Button
            mainPage
            onClick={() => {
              navigate(`/tenant-details/${customerInfo.tenantId}`);
            }}
            additionalstyle={`
            width:113px;
          `}
          >
            User Profile
          </Button>
        ) : null}
      </CardHeader>
      <FormContainer>
        <InputRow>
          <Input
            disabled={disabled || customerStatus === "PREVIOUS"}
            mainPage
            title="NAME"
            value={customerInfo.fullName || ""}
            error={customerInfoError.fullNameError}
            onChange={(e) => {
              dispatch(setCustomerInfo({ fullName: e.target.value }));
            }}
            additionalstyle={`
              width: 100%;
            `}
          />
          <Input
            disabled={disabled}
            hidden={mini}
            mainPage
            title="ORGANIZATION"
            value={customerInfo.organization || ""}
            error={customerInfoError.organizationError}
            onChange={(e) => {
              dispatch(
                setCustomerInfo({
                  organization: e.target.value,
                })
              );
            }}
            additionalstyle={`
              width: 100%;
            `}
          />
        </InputRow>
        <InputRow hidden={mini}>
          <div className="address">
            <Input
              disabled={disabled}
              mainPage
              title="STREET ADDRESS"
              inputFieldRef={ref}
              value={customerInfo.streetAddress || ""}
              error={customerInfoError.streetAddressError}
              onChange={(e) => {
                dispatch(
                  setCustomerInfo({
                    streetAddress: e.target.value,
                  })
                );
              }}
              additionalstyle={`
                width: 100%;
              `}
            />
          </div>
          <div className="address">
            <Input
              disabled={disabled}
              mainPage
              title="STREET ADDRESS LINE 2"
              value={customerInfo.streetAddressLine2 || ""}
              error={customerInfoError.streetAddressLine2Error}
              onChange={(e) => {
                dispatch(
                  setCustomerInfo({
                    streetAddressLine2: e.target.value,
                  })
                );
              }}
              additionalstyle={`
                width: 100%;
              `}
            />
          </div>
        </InputRow>
        <InputRow hidden={mini}>
          <div className="city">
            <Input
              disabled={disabled}
              mainPage
              title="CITY"
              value={customerInfo.city || ""}
              error={customerInfoError.cityError}
              onChange={(e) => {
                dispatch(
                  setCustomerInfo({
                    city: e.target.value,
                  })
                );
              }}
              additionalstyle={`
                width: 100%;
              `}
            />
          </div>
          <div className="province">
            <Input
              disabled={disabled}
              mainPage
              title="PROVINCE / STATE"
              value={customerInfo.province || ""}
              error={customerInfoError.provinceError}
              onChange={(e) => {
                dispatch(
                  setCustomerInfo({
                    province: e.target.value,
                  })
                );
              }}
              additionalstyle={`
                width: 100%;
              `}
            />
          </div>
          <div className="zipCode">
            <Input
              disabled={disabled}
              mainPage
              title="POSTAL / ZIP CODE"
              value={customerInfo.postalCode || ""}
              error={customerInfoError.postalCodeError}
              onChange={(e) => {
                dispatch(
                  setCustomerInfo({
                    postalCode: e.target.value,
                  })
                );
              }}
              additionalstyle={`
                width: 100%;
              `}
            />
          </div>
          <div className="country">
            <Input
              disabled={disabled}
              mainPage
              title="COUNTRY"
              value={customerInfo.country || ""}
              error={customerInfoError.countryError}
              onChange={(e) => {
                dispatch(
                  setCustomerInfo({
                    country: e.target.value,
                  })
                );
              }}
              additionalstyle={`
                width: 100%;
              `}
            />
          </div>
        </InputRow>
        <InputRow>
          <div className="email">
            <Input
              disabled={disabled || customerStatus === "PREVIOUS"}
              mainPage
              title="EMAIL"
              value={customerInfo.email || ""}
              error={customerInfoError.emailError}
              onChange={(e) => {
                dispatch(
                  setCustomerInfo({
                    email: e.target.value,
                  })
                );
              }}
            />
            {/* {customerInfo.userId ? (
              <SubscribeSlider
                type="email"
                userId={customerInfo.userId}
                left="50px"
              />
            ) : null} */}
          </div>
          <div className="phone">
            <PhoneNumberInput
              disabled={disabled || customerStatus === "PREVIOUS"}
              mainPage
              title="PHONE"
              error={customerInfoError.phoneNumberError}
              value={phoneNumber}
              onChangeNumber={handlePhoneChange}
              onPhoneValidityChange={handleValidityChange}
              onBlur={() => {          
                setCustomerInfoError((prev) => ({ 
                  ...prev,
                  phoneNumberError: !phoneNumberValidity && phoneNumber.length > 0
                }));
              }}
            />
            {/* {customerInfo.userId ? (
              <SubscribeSlider
                type="phone"
                userId={customerInfo.userId}
                left="56px"
              />
            ) : null} */}
          </div>
        </InputRow>
        <InputRow hidden={mini}>
          <Input
            disabled={disabled}
            mainPage
            title="TRAVEL DOCUMENT #"
            value={customerInfo.travelDocumentNumber || ""}
            onChange={(e) => {
              dispatch(
                setCustomerInfo({
                  travelDocumentNumber: e.target.value,
                })
              );
            }}
            additionalstyle={`
              width: 50%;

              @media only screen and (max-width: 767px) {
                width: 100%;
              }
            `}
          />
          <Dropdown
            disabled={disabled}
            mainPage
            options={["Passport", "Driver's License"]}
            title="TRAVEL DOCUMENT TYPE"
            value={customerInfo.travelDocumentType || ""}
            onChange={(e) => {
              dispatch(
                setCustomerInfo({
                  travelDocumentType: e,
                })
              );
            }}
            additionalstyle={`
              width: 50%;

              @media only screen and (max-width: 767px) {
                width: 100%;
              }
            `}
          />
        </InputRow>
        <Checkbox
          checked={customerInfo.isFirstNations}
          onChange={() => {
            dispatch(
              setCustomerInfo({ isFirstNations: !customerInfo.isFirstNations })
            );
          }}
          title={"First Nations Tax Exempt"}
        />
        {/* <InputRow hidden={mini}>
          <Input
            disabled={disabled}
            mainPage
            type="text"
            title="DATE OF BIRTH (MM/DD/YYYY)"
            value={customerInfo.dateOfBirth}
            error={customerInfoError.dateOfBirthError}
            errorMessage="Invalid date"
            onChange={(e) => {
              const input = e.target.value;

              // only allow numbers and '/'
              if (!/^\d*\/?\d*\/?\d*$/.test(input)) {
                return;
              }

              // length limit
              if (input.length > 10) {
                return;
              }

              // delete
              if (input.length < customerInfo.dateOfBirth?.length) {
                dispatch(
                  setCustomerInfo({
                    dateOfBirth: input,
                  })
                );
                setCustomerInfoError({
                  ...customerInfoError,
                  dateOfBirthError: false,
                });
                return;
              }

              // add '/'
              let formattedDate = input;
              if (input.length === 2 || input.length === 5) {
                formattedDate += "/";
              }

              // validation
              const parts = formattedDate?.split("/");
              const day = parts[0] ? parseInt(parts[0], 10) : null;
              const month = parts[1] ? parseInt(parts[1], 10) : null;
              const year = parts[2] ? parseInt(parts[2], 10) : null;

              if (parts[0] && parts[0].length === 2 && (day < 1 || day > 31)) {
                setCustomerInfoError({
                  ...customerInfoError,
                  dateOfBirthError: true,
                });
                return;
              }
              if (
                parts[1] &&
                parts[1].length === 2 &&
                (month < 1 || month > 12)
              ) {
                setCustomerInfoError({
                  ...customerInfoError,
                  dateOfBirthError: true,
                });
                return;
              }
              if (
                parts[2] &&
                parts[2].length === 4 &&
                (year < 1900 || year > currentYear)
              ) {
                setCustomerInfoError({
                  ...customerInfoError,
                  dateOfBirthError: true,
                });
                return;
              }

              dispatch(
                setCustomerInfo({
                  dateOfBirth: formattedDate,
                })
              );
              setCustomerInfoError({
                ...customerInfoError,
                dateOfBirthError: false,
              });
            }}
            additionalstyle={`
            width: calc(50% - 8px);

            @media only screen and (max-width: 767px) {
              width: 100%;
            }
          `}
          />
        </InputRow> */}
        <CardHeader>
          <div className="cardTitle">NOTIFICATION PREFERENCES</div>
        </CardHeader>
        <InputRow>
          <Checkbox
            checked={customerInfo.subscribedToMarketingEmails}
            onChange={() => {
              dispatch(
                setCustomerInfo({
                  subscribedToMarketingEmails: !customerInfo.subscribedToMarketingEmails,
                })
              );
            }}
            title={"Subscribed to marketing emails"}
          />
        </InputRow>
        <InputRow>
          <Checkbox
            checked={customerInfo.subscribedToMarketingTexts}
            onChange={() => {
              dispatch(
                setCustomerInfo({
                  subscribedToMarketingTexts: !customerInfo.subscribedToMarketingTexts,
                })
              );
            }}
            title={"Subscribed to marketing texts"}
          />
        </InputRow>
      </FormContainer>
      <div className="buttonContainer">{btnInfo}</div>
    </Card>
  );
};

export default GuestInformation;
